module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Spanish Warships"), _c('br'), _c('span', {
    staticClass: "fonts"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("in the Age of Sail")]), _c('br'), _vm._v("1700–1860")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Design, Construction, Careers and Fates")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("IF")]), _vm._v(" W"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("INFIELD")]), _vm._v(" J"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("OHN")]), _vm._v(" T"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("REDREA")]), _vm._v(" E"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("NRIQUE")]), _vm._v(" G"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ARCÍA")]), _vm._v("-T"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORRALBA")]), _vm._v(" P"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ÉREZ")]), _vm._v(" M"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ANUEL")]), _vm._v(" B"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("LASCO")]), _vm._v(" F"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ELIP")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b457524","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Title.vue
// module id = 63
// module chunks = 0